import React from 'react';
import { useSelector } from 'react-redux';
import { selectPermissions } from 'reducers/selectors';

const useIntegrations = () => {
  const { integrations } = useSelector(selectPermissions);

  const getPermittedIntegrationModuleAction = (module, moduleAction) => {
    if (!integrations?.[module]) return true; //if module not present in integrations means show for every tenant

    return integrations?.[module]?.[moduleAction];
  };

  const getPermittedIntegration = ({ module = '', moduleAction = 'active' }) => {
    return getPermittedIntegrationModuleAction(module, moduleAction);
  };

  return {
    getPermittedIntegration,
    integrations,
  };
};

export default useIntegrations;
